export enum MomentSecondsReplacements {
  EN = 'just now',
  DE = 'gerade',
  FR = 'à l’instant',
  NL = 'zojuist',
  SE = 'zojuist',
}

export const TIME_TRANSLATIONS: Record<string, [string, string][]> = {
  en: [
    [MomentSecondsReplacements.EN, '1s'],
    ['a minute', '1m'],
    [' minutes', 'm'],
    ['an hour', '1h'],
    [' hours', 'h'],
    ['a day', '1d'],
    [' days', 'd'],
    ['a month', '1mo'],
    [' months', 'mo'],
    ['a year', '1y'],
    [' years', 'y'],
  ],
  de: [
    [MomentSecondsReplacements.DE, '1s'],
    ['eine Minute', '1m'],
    [' Minuten', 'm'],
    ['eine Stunde', '1h'],
    [' Stunden', 'h'],
    ['ein Tag', '1T'],
    [' Tage', 'T'],
    ['ein Monat', '1M'],
    [' Monate', 'M'],
    ['ein Jahr', '1y'],
    [' Jahre', 'y'],
  ],
  fr: [
    [MomentSecondsReplacements.FR, '1s'],
    ['une minute', '1m'],
    [' minutes', 'm'],
    ['une heure', '1h'],
    [' heures', 'h'],
    ['un jour', '1j'],
    [' jours', 'j'],
    [' mois', 'M'],
    ['un mois', '1M'],
    ['un an', '1a'],
    [' ans', 'a'],
  ],
  nl: [
    [MomentSecondsReplacements.NL, '1s'],
    ['één minuut', '1m'],
    [' minuten', 'm'],
    ['één uur', '1h'],
    [' uur', 'h'],
    ['één dag', '1d'],
    [' dagen', 'd'],
    ['één maand', '1mo'],
    [' maanden', 'mo'],
    [' jaar', 'y'],
    ['één jaar', '1y'],
  ],
  se: [
    [MomentSecondsReplacements.SE, '1s'],
    ['één minuut', '1m'],
    [' minuten', 'm'],
    ['één uur', '1h'],
    [' uur', 'h'],
    ['één dag', '1d'],
    [' dagen', 'd'],
    ['één maand', '1mo'],
    [' maanden', 'mo'],
    [' jaar', 'y'],
    ['één jaar', '1y'],
  ],
};
